import {
  Avatar,
  Badge,
  Button,
  Col,
  Icon,
  Input,
  Popconfirm,
  Row,
  Switch,
  Table
} from 'antd';
import {inject, observer} from 'mobx-react';
import * as React from 'react';
import {Helmet} from 'react-helmet';
import Highlighter from 'react-highlight-words';
import {RouteComponentProps} from 'react-router';
import {Link} from 'react-router-dom';
import Card, {CardBody, CardHeader} from '../../components/Card';
import Layout, {Main} from '../../components/Layout';
import {PromoteListingListModelType} from '../../models/PromoteListingListModel';
import {UserDetailModelType} from '../../models/UserDetailModel';

// tslint:disable
interface WithInjectedProps extends RouteComponentProps<{userId: string}> {
  userDetail: UserDetailModelType;
  promoteListingList: PromoteListingListModelType;
}

interface UserDetailState {
  searchText: string;
}

@inject('userDetail', 'promoteListingList')
@observer
class UserDetail extends React.Component<{}, UserDetailState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      searchText: ''
    };
  }

  private get _userId() {
    return Number(this._withInjectedProps.match.params.userId);
  }
  componentDidMount() {
    this._withInjectedProps.userDetail.getUser(this._userId);
    this._withInjectedProps.promoteListingList.loadEntries(
      this._userId,
      20,
      0
    );
  }
  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }: any) => (
      <div style={{padding: 8}}>
        <Input
          // ref={node => {
          //   this.searchInput = node;
          // }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{width: 188, marginBottom: 8, display: 'block'}}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{width: 90, marginRight: 8}}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{width: 90}}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered: any) => (
      <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}} />
    ),
    onFilter: (value: any, record: any) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible: any) => {
      if (visible) {
        // setTimeout(() => this.searchInput.select());
      }
    },
    render: (text: string) => {
      console.log(text);
      return (
        <Highlighter
          highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      );
    }
  });

  handleSearch = (selectedKeys: any, confirm: any) => {
    confirm();
    this.setState({searchText: selectedKeys[0]});
  };

  handleReset = (clearFilters: any) => {
    clearFilters();
    this.setState({searchText: ''});
  };

  render() {
    const {isLoading, user} = this._withInjectedProps.userDetail;
    return (
      <React.Fragment>
        <Helmet>
          <title>User Detail</title>
        </Helmet>
        <Layout>
          <Main>
            <Card>
              <CardHeader>Basic Information</CardHeader>
              {isLoading ? this._loading() : this._detailUser(user)}
            </Card>
            <Card>
              <CardHeader>Promote Listings</CardHeader>
              <CardBody>{this._renderPromoteListing()}</CardBody>
            </Card>
          </Main>
        </Layout>
      </React.Fragment>
    );
  }

  private _buildColumnsPromoteListing() {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Image',
        dataIndex: 'image',
        key: 'image'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address'
      },
      {
        title: 'Publish',
        dataIndex: 'state',
        key: 'state'
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions'
      }
    ];
  }

  private onClickDeleteListing(listingId: number) {
    this._withInjectedProps.promoteListingList.deleteListing(listingId);
  }

  private _buildItemListing(listing: any) {
    const {id, name, images, internalName, address, state} = listing;
    const image = images && images.length > 0 ? images[0].url : '';
    return {
      key: id,
      id: (
        <Link to={`/users/${this._userId}/promote-listings/${id}/edit`}>
          {id}
        </Link>
      ),
      image: <Avatar size="large" src={image} shape="square" />,
      name: (
        <Row>
          <b>
            <Link to={`/users/${this._userId}/promote-listings/${id}/edit`}>
              {name}
            </Link>
          </b>
          <p style={{color: '#ffe58f'}}>{internalName}</p>
          <p>{address}</p>
        </Row>
      ),
      address: address,
      state: <Switch disabled={true} defaultChecked={state === 'ACTIVATED'} />,
      actions: (
        <Popconfirm
          title="Are you sure delete this listing?"
          onConfirm={() => this.onClickDeleteListing(id)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="danger" size="small" icon="delete" />
        </Popconfirm>
      )
    };
  }

  private _buildDataSourcePromoteListing(promoteListings: any) {
    return promoteListings.map((listing: any, index: any) => {
      return this._buildItemListing(listing);
    });
  }

  private _renderPromoteListing() {
    const {isLoading, entries} = this._withInjectedProps.promoteListingList;
    const promoteListings = Array.from(entries.values());
    return (
      <Row>
        <Button type="primary">
          <Link to={`${this._userId}/promote-listings`}>Create</Link>
        </Button>
        <Table
          loading={isLoading}
          columns={this._buildColumnsPromoteListing()}
          dataSource={this._buildDataSourcePromoteListing(promoteListings)}
        />
      </Row>
    );
  }
  private _detailUser(user: any) {
    if (!user) {
      return null;
    }
    let {experiences} = user;
    experiences = experiences || '';
    experiences = experiences.split('\n').map((item: string, idx: number) => {
      return <p key={idx}>{item}</p>;
    });
    return (
      <React.Fragment>
        <CardBody>
          <Row className="basic-info">
            <Col span={5}>
              <Avatar src={user.avatar} size={100} />
              <p className="team-name">{`${user.firstName} ${user.lastName}`}</p>
              <Row>
                <p>{user.location}</p>
              </Row>
            </Col>

            <Col span={16}>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Role
                </Col>
                <Col span={16} className="item-content">
                  <span style={{color: '#52c41a'}}>
                    {user.role ? user.role.name : 'Not set'}
                  </span>
                </Col>
              </Row>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Email
                </Col>
                <Col span={16} className="item-content">
                  {user.email}
                </Col>
              </Row>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Phone
                </Col>
                <Col span={16} className="item-content">
                  {user.phone}
                </Col>
              </Row>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Birth Day
                </Col>
                <Col span={16} className="item-content">
                  {user.birthDay}
                </Col>
              </Row>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Languages supported
                </Col>
                <Col span={16} className="item-content">
                  {user.languages}
                </Col>
              </Row>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Review by owner
                </Col>
                <Col span={16} className="item-content">
                  {user.reviewByOwner}
                </Col>
              </Row>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Review by guest
                </Col>
                <Col span={16} className="item-content">
                  {user.reviewByGuest}
                </Col>
              </Row>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Speed response
                </Col>
                <Col span={16} className="item-content">
                  {user.speedResponse}
                </Col>
              </Row>
              <Row className="item-basic">
                <Col span={8} className="item-header">
                  Number Listings
                </Col>
                <Col span={16} className="item-content">
                  {user.numberListings}
                </Col>
              </Row>
            </Col>

            <Col span={3}>
              <Button type="primary">
                <Link to={`/users/${user.id}/edit`}>
                  <Icon type="edit" />
                </Link>
              </Button>
            </Col>
          </Row>
          <h3 style={{fontSize: 20, fontWeight: 'bold', marginTop: 20}}>
            Experiences
          </h3>
          <Row>
            <div>{user.experiences ? experiences : 'Nothing here!'}</div>
          </Row>
          <h3 style={{fontSize: 20, fontWeight: 'bold', marginTop: 20}}>
            Teams <Badge count={user.teams.length} />
          </h3>

          <Row>
            <Row>
              <Table
                bordered={true}
                columns={this._dataHeaderTable()}
                dataSource={this._cvtDataMembers(user.teams)}
              />
            </Row>
          </Row>
        </CardBody>
      </React.Fragment>
    );
  }

  private _cvtDataMembers(teams: any) {
    return teams.map((team: any, idex: number) => {
      return this._itemTeamTable(team);
    });
  }

  private _itemTeamTable(team: any) {
    const {id, name, avatar, email, domainName} = team;
    return {
      key: id,
      id: id,
      avatar: <Avatar shape="square" src={avatar} />,
      name: name,
      email: email,
      domainName: domainName,
      actions: <Link to={`/teams/${id}`}>Details</Link>
    };
  }

  private _dataHeaderTable() {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Avatar',
        dataIndex: 'avatar',
        key: 'avatar'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        ...this.getColumnSearchProps('name')
      },
      {
        title: 'Domain Name',
        dataIndex: 'domainName',
        key: 'domainName',
        ...this.getColumnSearchProps('domainName')
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        ...this.getColumnSearchProps('email')
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions'
      }
    ];
  }

  private _loading() {
    return (
      <div style={{margin: 'auto'}}>
        <Button shape="circle" loading={true} />
      </div>
    );
  }
}

export default UserDetail;



// WEBPACK FOOTER //
// ./src/pages/UserDetail/UserDetail.tsx